import React from 'react';
import { Box, Container, Typography, Link as MuiLink, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        backgroundColor: '#1a1a1a',
        color: 'rgba(255, 255, 255, 0.7)',
      }}
    >
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Box
              sx={{
                maxWidth: '900px',
                mb: 4,
                mx: 'auto',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  textAlign: 'left',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                }}
              >
                <Box sx={{ flex: '0 0 auto' }}>
                  <img
                    src="/logo_w.svg"
                    alt="Логотип Фонда содействия инновациям"
                    style={{ width: '160px', height: 'auto' }}
                  />
                </Box>
                <Box sx={{ flex: '1 1 300px' }}>
                  <Typography
                    variant="body2"
                    className="pencil-text"
                    sx={{ lineHeight: 1.6 }}
                  >
                    ⁠Проект создан при поддержке Федерального государственного бюджетного учреждения "Фонд содействия развитию малых форм предприятий в научно-технической сфере" в рамках программы "Студенческий стартап" федерального проекта "Платформа университетского технологического предпринимательства".
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 4,
                mb: 4,
              }}
            >
              <MuiLink
                href="#"
                underline="hover"
                sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
              >
                Условия использования
              </MuiLink>
              <MuiLink
                href="#"
                underline="hover"
                sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
              >
                Контакты
              </MuiLink>
            </Box>

            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.5)' }}>
              &copy; {currentYear} GameGuard AI. Все права защищены.
            </Typography>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 